var _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdsr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 192.1 125.6",
    style: {
      enableBackground: "new 0 0 192.1 125.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_43_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_50_",
    d: "M4.7,129.5c17.2-36,34.5-71.9,51.7-107.9c2.4-5.1,4.9-10.1,7.3-15.2c3.3-6.9-7-13-10.4-6.1 c-17.2,36-34.5,71.9-51.7,107.9c-2.4,5.1-4.9,10.1-7.3,15.2C-9,130.4,1.4,136.5,4.7,129.5L4.7,129.5z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_44_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_59_",
    d: "M53.4,4.3c6.6,20.7,13.1,41.4,19.7,62.2c2.3,7.3,13.9,4.2,11.6-3.2C78.1,42.6,71.5,21.9,65,1.2 C62.6-6.2,51-3,53.4,4.3L53.4,4.3z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_42_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_58_",
    d: "M79,72.6c26.4,0,52.9,0,79.3,0c7.7,0,7.7-12,0-12c-26.4,0-52.9,0-79.3,0C71.3,60.6,71.3,72.6,79,72.6 L79,72.6z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_60_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_64_",
    d: "M153.2,68.6c11.3,20.8,22.5,41.7,33.8,62.5c3.7,6.8,14,0.7,10.4-6.1c-11.3-20.8-22.5-41.7-33.8-62.5 C159.8,55.8,149.5,61.8,153.2,68.6L153.2,68.6z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdsr);
export default __webpack_public_path__ + "static/media/adsr.f82159726871adf5d9732712ab42ab80.svg";
export { ForwardRef as ReactComponent };